import { CSSProperties, FC, useEffect, useState } from 'react';
import { message, Typography } from 'antd';
import { CheckOutlined, DownloadOutlined } from '@ant-design/icons';
import apiRequests from 'utils/api';
import apiRoutes from 'config/apiRoute';
import asyncErrorHandler from 'utils/asyncErrorHandler';
import styles from './style.module.less';

export interface ButtonDownloadAllFilesProps {
  resource: 'task' | 'request' | 'file';
  ids: string[];
  style?: CSSProperties;
  label?: string;
  showZippingLabel?: boolean;
}

const ButtonDownloadAllFiles: FC<ButtonDownloadAllFilesProps> = ({
  resource,
  ids,
  style,
  label = 'Download all files',
  showZippingLabel,
}) => {
  const [downloading, setDownloading] = useState(false);
  const [displayZippingLabel, setDisplayZippingLabel] = useState(false);

  const clickHandler = async () => {
    try {
      setDownloading(true);

      const res = await apiRequests.post(`${apiRoutes.MASS_DOWNLOAD}`, {
        full_download: true,
        [`${resource}_ids`]: ids,
      });

      if (showZippingLabel) {
        setDisplayZippingLabel(true);
      } else {
        message.success(res?.data?.message);
      }
    } catch (error) {
      asyncErrorHandler(error);
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    if (!displayZippingLabel) return () => {};

    const timeout = setTimeout(() => setDisplayZippingLabel(false), 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, [displayZippingLabel]);

  return (
    <>
      {displayZippingLabel && (
        <Typography.Text type="secondary" style={{ paddingRight: 8, fontSize: 12 }}>
          Zipping files <CheckOutlined />
        </Typography.Text>
      )}
      <button type="button" onClick={clickHandler} className={styles.btnDownloadAll} style={style} disabled={downloading}>
        <DownloadOutlined />
        {label}
      </button>
    </>
  );
};

export default ButtonDownloadAllFiles;
